import { ColumnsType } from "antd/lib/table";
import { ProfileComponent } from "../../components/common/ProfileComponent";
import { IAdminDetail } from "../../interfaces/admin";
import { CenterColumns, TdEmail, TdPhone, TdRole } from "./index.style";

export default function conversDataToTableRowsDatabaseAdminPage(
  dataUsers: IAdminDetail[]
) {
  return dataUsers.map((item) => [
    <ProfileComponent
      name={`${item.firstName} ${item.lastName}`}
      avatar={item.imageUrl || ""}
      lineId={item.displayName}
      style={{ minWidth: "280px" }}
    />,
    <TdPhone>{item.phone}</TdPhone>,
    <TdEmail>{item.email}</TdEmail>,
    <TdRole>{item.role}</TdRole>,
  ]);
}

export const columns: ColumnsType<IAdminDetail> = [
  {
    title: <CenterColumns>ชื่อ-นามสกุล</CenterColumns>,
    dataIndex: "name",
    key: "name",
    render: (_: string, record: IAdminDetail) => (
      <ProfileComponent
        name={`${record.firstName} ${record.lastName}`}
        avatar={record.imageUrl || ""}
        lineId={record.displayName}
      />
    ),
  },
  {
    title: <CenterColumns>เบอร์โทรศัพท์</CenterColumns>,
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: <CenterColumns>อีเมลที่ใช้งาน</CenterColumns>,
    dataIndex: "email",
    key: "email",
    ellipsis: true,
  },
  {
    title: <CenterColumns>สิทธิ์การเข้าถึง</CenterColumns>,
    dataIndex: "role",
    key: "role",
  },
];
